module.exports = {
  environmentName: 'development',
  contextHubInstance: global.ContextHub,
  originDomain: 'https://origin-local.adobecqms.net:4443/',
  apiUrls: {
    plans: 'https://localhost:4567/api/plans.json',
  },
};
